/* eslint-disable no-unused-vars, no-loop-func */
// ASD PDF REPORT GENERATOR v1.1
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { LOGO_BASE64, LOGO_FORMAT } from "./boalLogo";

var ASD_TEAL = [8, 145, 178], NAVY = [26, 39, 68], GRAY = [100, 100, 100], WHITE = [255, 255, 255];
var VER = "1.0.0";
var PAGE_TITLE = "Early Warning Detection System Report";
var HEADER_TEXT = "Early Warning Detection System Report";
var BOM_TITLE = "ASD System BOM";

function fmtDate() { return new Date().toISOString().replace("T", " ").slice(0, 19); }
function addFooter(doc, pg) { var pw = doc.internal.pageSize.getWidth(), ph = doc.internal.pageSize.getHeight(); doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY); doc.text("Software Version " + VER + "    Calculation Performed: " + fmtDate() + " EST", pw / 2, ph - 15, { align: "center" }); doc.text("Page " + pg, pw - 20, ph - 15, { align: "right" }); doc.text("Copyright \u00A9 Boal Systems Inc. Fort Lauderdale, FL USA", pw / 2, ph - 10, { align: "center" }); }
function addLogo(doc, x, y, w, h) { try { if (LOGO_BASE64) { doc.setFillColor(255,255,255); doc.rect(x,y,w,h,"F"); doc.addImage(LOGO_BASE64, LOGO_FORMAT||"JPEG", x, y, w, h); } } catch(e){} }
function lv(doc, label, value, x, y, lw) { doc.setFont("helvetica","normal"); doc.setTextColor.apply(doc, GRAY); doc.text(label, x, y); doc.setTextColor(0,0,0); doc.text(String(value||"\u2014").substring(0,60), x+(lw||42), y); }

export function generateASDReport(form, result, isMetric, pipeNetworks) { var doc = buildASDDoc(form, result, isMetric, pipeNetworks); doc.save((form.projectName || "ASD_System").replace(/[^a-zA-Z0-9_-]/g, "_") + "_Boal_ASD_System_Report.pdf"); }
export function generateASDReportBase64(form, result, isMetric, pipeNetworks) { var doc = buildASDDoc(form, result, isMetric, pipeNetworks); var fn = (form.projectName || "ASD_System").replace(/[^a-zA-Z0-9_-]/g, "_") + "_Boal_ASD_System_Report.pdf"; return { base64: doc.output("datauristring").split(",")[1], fileName: fn, mimeType: "application/pdf" }; }

function buildASDDoc(form, result, isMetric, pipeNetworks) {
  var zoneR = result.zoneResults || [], aggBom = result.aggregatedBom || [];
  var doc = new jsPDF("p","mm","letter"), pw = doc.internal.pageSize.getWidth(), m = 20, uL = isMetric ? "m" : "ft", pg = 1;

  // === PAGE 1: Cover ===
  addLogo(doc, pw/2-20, 10, 40, 40);
  doc.setFontSize(16); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, ASD_TEAL);
  doc.text(PAGE_TITLE, pw/2, 60, { align: "center" });
  doc.setFontSize(14); doc.setTextColor(0,0,0);
  doc.text(form.company || form.designerName || "\u2014", pw/2, 72, { align: "center" });

  var y = 84; doc.setFontSize(10);
  [["Designer:", form.designerName], ["Email:", form.email], ["Phone:", form.phone]].forEach(function(p) { doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, ASD_TEAL); doc.text(p[0], m, y); doc.setFont("helvetica","normal"); doc.setTextColor(0,0,0); doc.text(String(p[1]||"\u2014"), m+35, y); y+=6; });

  y+=4; doc.setFontSize(12); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, ASD_TEAL);
  doc.text("Project Information", pw/2, y, {align:"center"}); y+=8; doc.setFontSize(9);
  [["Project Name:", form.projectName],["Location:", form.projectLocation],["Country:", form.country],["Notes:", form.notes]].forEach(function(p) { lv(doc, p[0], p[1], m, y, 35); y+=5.5; });

  y+=4; doc.setFontSize(12); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, ASD_TEAL);
  doc.text("System Requirements", pw/2, y, {align:"center"}); y+=8; doc.setFontSize(9);
  var lc = m, rc = pw/2+10, lw2 = 38;
  var left = [["Unit System:", isMetric?"Metric":"Imperial"],["Detection Objective:", (form.detectionObjective||"\u2014").substring(0,32)],["Design Standard:", (form.designStandard||"\u2014").substring(0,32)],["Temp/Humidity Sensors:", form.tempHumiditySensors||"No"],["Network Module:", form.networkRequired||"No"],["Pipe Addressability:", form.pipeAddressability||"No"]];
  var right = [["Area Type:", form.areaType||"\u2014"],["Environment:", form.environment||"\u2014"],["Monoxide Detection:", form.coDetection||"No"],["Remote Display:", form.remoteDisplay||"No"],["Include Labels:", form.includeLabels||"No"],["Ceiling Type:", form.ceilingType||"\u2014"]];
  var mx = Math.max(left.length, right.length);
  for (var i=0; i<mx; i++) { if (i<left.length) lv(doc, left[i][0], left[i][1], lc, y, lw2); if (i<right.length) lv(doc, right[i][0], right[i][1], rc, y, lw2); y+=5.5; }
  var extraRows = [];
  if (form.hasSuppression) extraRows.push(["Suppression in Enclosure:", form.hasSuppression]);
  if (form.temperature) extraRows.push(["Est. Temperature:", form.temperature + (isMetric?" \u00B0C":" \u00B0F")]);
  if (form.highAirflow==="Yes") extraRows.push(["High Airflow:", "Yes"]);
  if (form.hazardous==="Yes") extraRows.push(["Hazardous/Explosive:", "Yes"]);
  for (var ef=0; ef<extraRows.length; ef++) { lv(doc, extraRows[ef][0], extraRows[ef][1], lc, y, lw2); y+=5.5; }

  if (zoneR.length > 0) {
    y+=4; doc.setFontSize(12); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, ASD_TEAL);
    doc.text("Zone Details", pw/2, y, {align:"center"}); y+=4;
    var zRows = zoneR.map(function(r) { return [r.name, r.zoneType, String(r.mainL||""), String(r.mainW||""), String(r.mainH||""), r.area+" m\u00B2", r.detector.name, String(r.detectorQty)]; });
    autoTable(doc, { startY: y, head: [["Zone","Type","L ("+uL+")","W ("+uL+")","H ("+uL+")","Area","Detector","Qty"]], body: zRows, margin:{left:m,right:m}, headStyles:{fillColor:ASD_TEAL,textColor:WHITE,fontStyle:"bold",fontSize:8}, bodyStyles:{fontSize:8}, columnStyles:{0:{cellWidth:20},1:{cellWidth:22},6:{cellWidth:30}} });
  }
  addFooter(doc, pg);

  // === PAGE 2: Per-Zone BOM ===
  if (zoneR.length > 0) {
    doc.addPage(); pg++;
    addLogo(doc, m, 8, 25, 25);
    doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
    doc.text(HEADER_TEXT, m+28, 18);
    doc.setFontSize(14); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, NAVY);
    doc.text(BOM_TITLE, pw/2, 42, {align:"center"});
    doc.setFontSize(11); doc.text("Per-Zone Breakdown", m, 54);
    y = 60;
    for (var j=0; j<zoneR.length; j++) {
      var zr = zoneR[j];
      if (y > 220) { addFooter(doc, pg); doc.addPage(); pg++; y = 20; }
      doc.setFontSize(9); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, NAVY);
      doc.text(zr.name + " (" + zr.zoneType + ")  |  " + zr.detector.name + " x " + zr.detectorQty + "  |  " + zr.totalSamplingPoints + " sampling pts | " + zr.physicalHoles + " physical holes", m, y); y+=3;
      autoTable(doc, { startY: y, head:[["Part Number","Description","Qty"]], body: zr.items.map(function(it) { return [it.pn, it.desc, String(it.qty)]; }), margin:{left:m,right:m}, headStyles:{fillColor:ASD_TEAL,textColor:WHITE,fontStyle:"bold",fontSize:8}, bodyStyles:{fontSize:8,textColor:[50,50,50]}, alternateRowStyles:{fillColor:[245,245,245]}, columnStyles:{0:{cellWidth:50,fontStyle:"bold"},2:{cellWidth:15,halign:"center"}} });
      y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y+20) + 8;
    }
    addFooter(doc, pg);
  }

  // === PAGE 3: Aggregated BOM ===
  doc.addPage(); pg++;
  addLogo(doc, m, 8, 25, 25);
  doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
  doc.text(HEADER_TEXT, m+28, 18);
  doc.setFontSize(14); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, NAVY);
  doc.text(BOM_TITLE, pw/2, 42, {align:"center"});
  y = 54; doc.setFontSize(11); doc.text("Aggregated Project BOM \u2014 Order Summary", m, y); y+=4;
  doc.setFontSize(9); doc.setFont("helvetica","normal"); doc.setTextColor.apply(doc, GRAY);
  doc.text("Total Detectors: " + result.totalDetectors + "  |  Sampling Points: " + result.totalSamplingPoints + "  |  Physical Holes: " + result.totalPhysicalHoles + "  |  Zones: " + zoneR.length, m, y+2); y+=10;
  autoTable(doc, { startY: y, head:[["Part Number","Description","Qty"]], body: aggBom.map(function(r) { return [r.pn, r.desc, String(r.qty)]; }), margin:{left:m,right:m}, headStyles:{fillColor:ASD_TEAL,textColor:WHITE,fontStyle:"bold",fontSize:9}, bodyStyles:{fontSize:9,textColor:[30,30,30]}, alternateRowStyles:{fillColor:[240,240,240]}, columnStyles:{0:{cellWidth:50,fontStyle:"bold"},2:{cellWidth:18,halign:"center",fontStyle:"bold"}} });
  addFooter(doc, pg);


  // === PIPE NETWORK PAGES (if any saved) ===
  if (pipeNetworks && typeof pipeNetworks === "object") {
    var pnKeys = Object.keys(pipeNetworks);
    for (var pk = 0; pk < pnKeys.length; pk++) {
      var pnIdx = parseInt(pnKeys[pk]);
      var pnData = pipeNetworks[pnKeys[pk]];
      if (!pnData || !pnData.network || !pnData.network.nodes) continue;
      var pNet = pnData.network;
      var pZoneName = (zoneR[pnIdx] ? zoneR[pnIdx].name : "Zone " + (pnIdx + 1));

      doc.addPage(); pg++;
      addLogo(doc, m, 8, 25, 25);
      doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
      doc.text(HEADER_TEXT, m+28, 18);
      doc.setFontSize(14); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, NAVY);
      doc.text("Pipe Network Drawing", pw/2, 42, {align:"center"});
      doc.setFontSize(10); doc.text(pZoneName, m, 52);

      // Draw the network using jsPDF primitives
      var drawY = 58, drawH = 160, drawW = pw - m * 2;
      var dCx = m + drawW / 2, dCy = drawY + drawH / 2;
      doc.setDrawColor(210,210,210); doc.setLineWidth(0.15); doc.rect(m, drawY, drawW, drawH);

      // Bounds
      var nMnx = Infinity, nMny = Infinity, nMxx = -Infinity, nMxy = -Infinity;
      function pIso(x,y,z) { return { sx: (x-y)*0.866, sy: (x+y)*0.5-z }; }
      function pnById(id) { return pNet.nodes.find(function(n) { return n.id === id; }); }
      for (var ni2=0; ni2<pNet.nodes.length; ni2++) { var pp=pIso(pNet.nodes[ni2].x, pNet.nodes[ni2].y, pNet.nodes[ni2].z||0); if(pp.sx<nMnx)nMnx=pp.sx; if(pp.sy<nMny)nMny=pp.sy; if(pp.sx>nMxx)nMxx=pp.sx; if(pp.sy>nMxy)nMxy=pp.sy; }
      if (pNet.nodes.length <= 1) { nMnx=-50; nMxx=50; nMny=-50; nMxy=50; }
      var nW2=Math.max(nMxx-nMnx,80), nH2=Math.max(nMxy-nMny,80);
      var sc2=Math.min(drawW/(nW2+80), drawH/(nH2+80), 0.85);
      var cx2=(nMnx+nMxx)/2, cy2=(nMny+nMxy)/2;
      function ptx(sx) { return dCx+(sx-cx2)*sc2; }
      function pty(sy) { return dCy+(sy-cy2)*sc2; }

      // Draw edges
      for (var ei2=0; ei2<pNet.edges.length; ei2++) {
        var eg2=pNet.edges[ei2];
        var fn2=pnById(eg2.from), tn2=pnById(eg2.to);
        if (!fn2||!tn2) continue;
        var fp2=pIso(fn2.x,fn2.y,fn2.z||0), tp2=pIso(tn2.x,tn2.y,tn2.z||0);
        var x12=ptx(fp2.sx), y12=pty(fp2.sy), x22=ptx(tp2.sx), y22=pty(tp2.sy);
        doc.setDrawColor(139,26,26); doc.setLineWidth(0.4);
        doc.line(x12,y12,x22,y22);
        // Holes as small circles
        var hc2=parseInt(eg2.holes)||0;
        for (var hh=0; hh<hc2; hh++) { var ht=(hh+1)/(hc2+1); doc.setFillColor(252,211,77); doc.setDrawColor(139,26,26); doc.setLineWidth(0.1); doc.circle(x12+(x22-x12)*ht, y12+(y22-y12)*ht, 0.8, "FD"); }
        // Tube drops
        var dc2=parseInt(eg2.tubingDrops)||0;
        for (var dd=0; dd<dc2; dd++) { var dt2=(dd+1)/(dc2+1); var ddx=x12+(x22-x12)*dt2, ddy=y12+(y22-y12)*dt2; doc.setDrawColor(249,115,22); doc.setLineWidth(0.2); doc.line(ddx,ddy,ddx,ddy+5); doc.circle(ddx,ddy+5,0.6,"FD"); }
        // Label
        var mx2=(x12+x22)/2, my2=(y12+y22)/2;
        doc.setFont("helvetica","normal"); doc.setFontSize(4.5); doc.setTextColor.apply(doc, NAVY);
        doc.text(eg2.length+uL, mx2, my2-1.5);
      }

      // Draw nodes
      for (var ni3=0; ni3<pNet.nodes.length; ni3++) {
        var nd2=pNet.nodes[ni3], np2=pIso(nd2.x,nd2.y,nd2.z||0);
        var nx2=ptx(np2.sx), ny2=pty(np2.sy);
        if (nd2.type==="detector") {
          doc.setFillColor(209,213,219); doc.setDrawColor(31,41,55); doc.setLineWidth(0.3);
          doc.rect(nx2-5, ny2-3, 10, 8, "FD");
          doc.setFontSize(3.5); doc.setTextColor(31,41,55); doc.text("DET", nx2-3, ny2+10);
        } else if (nd2.type==="pipestart") {
          doc.setFillColor(31,41,55); doc.setDrawColor(31,41,55); doc.setLineWidth(0.2);
          doc.rect(nx2-1.5, ny2-3, 3, 4, "FD");
        } else if (nd2.type==="tee") {
          doc.setFillColor(254,249,195); doc.setDrawColor(217,119,6); doc.setLineWidth(0.2);
          doc.rect(nx2-1.5, ny2-1.5, 3, 3, "FD");
        } else {
          doc.setFillColor(236,253,245); doc.setDrawColor(5,150,105); doc.setLineWidth(0.15);
          doc.circle(nx2, ny2, 1, "FD");
        }
      }

      // Legend
      var ly2 = drawY + drawH + 6;
      doc.setFont("helvetica","normal"); doc.setFontSize(5); doc.setTextColor.apply(doc, GRAY);
      doc.setDrawColor(139,26,26); doc.setLineWidth(0.3); doc.line(m+3,ly2,m+12,ly2); doc.text("Pipe (3/4 in CPVC)", m+14, ly2+1);
      doc.setFillColor(252,211,77); doc.circle(m+55,ly2,0.8,"FD"); doc.text("Sampling Hole", m+58, ly2+1);
      doc.setDrawColor(249,115,22); doc.line(m+90,ly2,m+90,ly2+3); doc.text("Tube Drop", m+93, ly2+1);
      addFooter(doc, pg);

      // === TOP-DOWN VIEW (plan view) ===
      doc.addPage(); pg++;
      addLogo(doc, m, 8, 25, 25);
      doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
      doc.text(HEADER_TEXT, m+28, 18);
      doc.setFontSize(14); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, NAVY);
      doc.text("Pipe Network — Top-Down View", pw/2, 42, {align:"center"});
      doc.setFontSize(10); doc.text(pZoneName, m, 52);
      var td_drawY = 58, td_drawH = 160, td_drawW = pw - m * 2;
      var td_dCx = m + td_drawW / 2, td_dCy = td_drawY + td_drawH / 2;
      doc.setDrawColor(210,210,210); doc.setLineWidth(0.15); doc.rect(m, td_drawY, td_drawW, td_drawH);
      // Top-down: use x,y directly (no iso), ignore z
      var td_mnx=Infinity, td_mny=Infinity, td_mxx=-Infinity, td_mxy=-Infinity;
      for (var td_i=0; td_i<pNet.nodes.length; td_i++) { var td_n=pNet.nodes[td_i]; if(td_n.x<td_mnx)td_mnx=td_n.x; if(td_n.y<td_mny)td_mny=td_n.y; if(td_n.x>td_mxx)td_mxx=td_n.x; if(td_n.y>td_mxy)td_mxy=td_n.y; }
      if (pNet.nodes.length<=1){td_mnx=-50;td_mxx=50;td_mny=-50;td_mxy=50;}
      var td_nW=Math.max(td_mxx-td_mnx,80), td_nH=Math.max(td_mxy-td_mny,80);
      var td_sc=Math.min(td_drawW/(td_nW+80), td_drawH/(td_nH+80), 0.85);
      var td_cx=(td_mnx+td_mxx)/2, td_cy=(td_mny+td_mxy)/2;
      function td_tx(x){return td_dCx+(x-td_cx)*td_sc;} function td_ty(y){return td_dCy+(y-td_cy)*td_sc;}
      for (var td_ei=0;td_ei<pNet.edges.length;td_ei++){var td_eg=pNet.edges[td_ei];var td_fn=pnById(td_eg.from),td_tn=pnById(td_eg.to);if(!td_fn||!td_tn)continue;doc.setDrawColor(139,26,26);doc.setLineWidth(0.4);doc.line(td_tx(td_fn.x),td_ty(td_fn.y),td_tx(td_tn.x),td_ty(td_tn.y));var td_hc=parseInt(td_eg.holes)||0;for(var td_h=0;td_h<td_hc;td_h++){var td_ht=(td_h+1)/(td_hc+1);doc.setFillColor(252,211,77);doc.setDrawColor(139,26,26);doc.setLineWidth(0.1);doc.circle(td_tx(td_fn.x)+(td_tx(td_tn.x)-td_tx(td_fn.x))*td_ht,td_ty(td_fn.y)+(td_ty(td_tn.y)-td_ty(td_fn.y))*td_ht,0.8,"FD");}var td_mx=(td_tx(td_fn.x)+td_tx(td_tn.x))/2,td_my=(td_ty(td_fn.y)+td_ty(td_tn.y))/2;doc.setFont("helvetica","normal");doc.setFontSize(4.5);doc.setTextColor.apply(doc,NAVY);doc.text(td_eg.length+uL,td_mx,td_my-1.5);}
      for (var td_ni=0;td_ni<pNet.nodes.length;td_ni++){var td_nd=pNet.nodes[td_ni];var td_nx=td_tx(td_nd.x),td_ny=td_ty(td_nd.y);if(td_nd.type==="detector"){doc.setFillColor(209,213,219);doc.setDrawColor(31,41,55);doc.setLineWidth(0.3);doc.rect(td_nx-5,td_ny-3,10,8,"FD");doc.setFontSize(3.5);doc.setTextColor(31,41,55);doc.text("DET",td_nx-3,td_ny+10);}else if(td_nd.type==="pipestart"){doc.setFillColor(31,41,55);doc.setLineWidth(0.2);doc.rect(td_nx-1.5,td_ny-2,3,3,"FD");}else if(td_nd.type==="tee"){doc.setFillColor(254,249,195);doc.setDrawColor(217,119,6);doc.setLineWidth(0.2);doc.rect(td_nx-1.5,td_ny-1.5,3,3,"FD");}else{doc.setFillColor(236,253,245);doc.setDrawColor(5,150,105);doc.setLineWidth(0.15);doc.circle(td_nx,td_ny,1,"FD");}}
      var td_ly = td_drawY + td_drawH - 4;
      doc.setFont("helvetica","normal"); doc.setFontSize(5); doc.setTextColor.apply(doc, GRAY);
      doc.text("N", m + td_drawW/2, td_drawY + 4); doc.text("S", m + td_drawW/2, td_drawY + td_drawH - 2);
      doc.text("W", m + 3, td_drawY + td_drawH/2); doc.text("E", m + td_drawW - 6, td_drawY + td_drawH/2);
      addFooter(doc, pg);

      // === PIPING BOM TABLE — own page ===
      doc.addPage(); pg++;
      addLogo(doc, m, 8, 25, 25);
      doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
      doc.text(HEADER_TEXT, m+28, 18);
      if (pnData.summary) {
        var pBomY = 42;
        doc.setFontSize(9); doc.setFont("helvetica","bold"); doc.setTextColor.apply(doc, NAVY);
        doc.text("Piping Summary", m, pBomY);
        var pipeBomRows = [
          ["Total Pipe Length", pnData.summary.totalLen + " " + uL],
          ["Pipe Segments", String(pnData.summary.segments)],
          ["Tees (ASP-0010)", String(pnData.summary.tees)],
          ["90\u00B0 Elbows", String(pnData.summary.elbows90 || 0)],
          ["45\u00B0 Elbows (ASP-0008)", String(pnData.summary.elbows45 || 0)],
          ["End Caps (ASP-0009)", String(pNet.nodes.filter(function(n) { var ee=pNet.edges.filter(function(e){return e.from===n.id||e.to===n.id;}); return n.type!=="detector"&&n.type!=="pipestart"&&ee.length<=1; }).length)],
          ["Sampling Holes", String(pnData.summary.holes)],
          ["Tube Drops", String(pnData.summary.drops)],
        ];
        autoTable(doc, { startY: pBomY+2, head:[["Item","Qty"]], body: pipeBomRows, margin:{left:m,right:m}, headStyles:{fillColor:ASD_TEAL,textColor:WHITE,fontStyle:"bold",fontSize:8}, bodyStyles:{fontSize:8}, columnStyles:{0:{cellWidth:80},1:{cellWidth:30,halign:"center"}} });
      }
      addFooter(doc, pg);
    }
  }

  return doc;
}
